import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-riti-alternativi-view',
  templateUrl: './form-riti-alternativi-view.component.html',
  styleUrls: ['./form-riti-alternativi-view.component.css']
})
export class FormRitiAlternativiViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
